<template>
    <ResourceAttachSelect
        title="New Flashcards"
        label="Flashcard set"
        select-id="new_flashcards"
        type="flashcards"
        :options="flashcardOptions"
        @cancel="$emit('cancel')"
        @attach="$emit('attach', $event)"
    />
</template>

<script lang="ts">
import axios from "axios";
import ResourceAttachSelect from "./ResourceAttachSelect.vue";

export default {
    components: {
        ResourceAttachSelect,
    },
    props: {
        lessonId: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            flashcardOptions: [],
        };
    },
    methods: {
        async getFlashcardOptions() {
            try {
                const response = await axios.get(
                    "/api/learn/resources/flashcards/options"
                );
                this.flashcardOptions = response.data ?? [];
            } catch {
                this.flashcardOptions = [];
            }
        },
    },
    mounted() {
        this.getFlashcardOptions();
    },
};
</script>
